import React from "react";
import { useSelector } from "react-redux";
import { Chip } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { selectDataTableUnifiedState } from "../../../../redux/selectors/unifiedSelectors";
import { customFilterHeaderStyles } from "./CustomFilterHeaderStyles";

interface CustomFilterHeaderProps {
  field: string;
}

const CustomFilterHeader: React.FC<CustomFilterHeaderProps> = ({ field }) => {
  const { filterModel } = useSelector(selectDataTableUnifiedState);

  const columnFiltersCount =
    filterModel?.items?.filter(
      (item) => item.field === field && item.operator && item.value
    ).length || 0;

  if (columnFiltersCount === 0) {
    return null;
  }

  return (
    <div style={customFilterHeaderStyles.container}>
      <FilterAltIcon sx={customFilterHeaderStyles.filterIcon} />
      <Chip
        label={columnFiltersCount}
        size="small"
        sx={customFilterHeaderStyles.filterChip}
      />
    </div>
  );
};

export default CustomFilterHeader;
